module.exports = __webpack_public_path__ + "static/media/email.cf78973c.svg";